<template>
  <div class="cmp-settings-accounting-tax_groups">
    <NTable
      :id="'settings-accounting-tax_groups'"
      class="h2 dbox1"
      :headers="headers"
      :items="tax_groups"
      :config="tableConfig"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('tax_groups')">
            <div class="ut-rowcen">
              <input
                type="radio"
                :checked="isSelected(item)"
                @change="e => onSelectTaxGroup(item)"
                value="tax_group"
                name="tax_group"
              />
            </div>
          </td>
          <td
            v-bind="tdcon('tax_group_name')"
            style="cursor: pointer"
            @click="e => onSelectTaxGroup(item)"
          >
            <span>{{ item.tax_group_name }}</span>
          </td>
          <td v-bind="tdcon('options')">
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                class="dt-icon v5 s2"
                @click="e => onDeleteTaxGroup(item)"
                :alt="$t('delete_tax_group')"
                :title="$t('delete_tax_group')"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </div>
</template>

<script>
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";

export default {
  components: {
    NTable
  },
  props: {
    accountingSettingsData: {
      type: Object,
      default: () => []
    },
    selectedTaxGroup: {
      type: Object
    }
  },
  data: function() {
    return {
      tableConfig: createNTableConfig({
        rowHeight: 32,
        fullHeight: true,
        showHeader: false
      })
    };
  },
  computed: {
    tax_groups: function() {
      return this.accountingSettingsData?.tax_groups || [];
    },
    headers: function() {
      return [
        createTableHeader("tax_groups", {
          text: false,
          mw: 50
        }),
        createTableHeader("tax_group_name", {
          text: false,
          f: 2
        }),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    }
  },
  methods: {
    onAddMoneyDetailsItemClick: function() {
      this.$emit("add_click", true);
    },
    onDeleteTaxGroup: function(taxGroup) {
      this.$emit("delete", taxGroup);
    },
    onSelectTaxGroup: function(item) {
      this.$emit("selected", item);
    },
    isSelected: function(item) {
      return (
        (this.selectedTaxGroup &&
          item?.tax_group_id == this.selectedTaxGroup?.tax_group_id) ||
        item?.tax_group_name == this.selectedTaxGroup?.tax_group_name
      );
    }
    // MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-accounting-tax_groups {
  height: 100%;
  .dt-ntable {
    // --ntable-height: 277px;
    .tax_groups {
      > div {
        display: flex;
        align-items: center;
      }
      input {
        cursor: pointer;
      }
    }
  }
}
</style>
